import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32f2bc5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pay" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "付款账户信息", -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "开户名：", -1))
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "开户银行：", -1))
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "开户支行：", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "银行账号：", -1))
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "item red" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "转账备注：", -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "center_copy" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("一键复制")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "订单信息", -1))
const _hoisted_22 = { class: "content" }
const _hoisted_23 = { class: "item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "项目名称：", -1))
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "项目编号：", -1))
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "订单金额：", -1))
const _hoisted_31 = { class: "value" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createTextVNode(" 请您尽快完成保费支付，支付时间超过保证金截止时间会导致投标失败；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 使用企业基本户转账支付时，请填写转账备注，忘记转账备注或备注填写错误将导致支付失败；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 如有疑问，请联系客服4006-712-925 ")
], -1))
const _hoisted_33 = {
  key: 0,
  class: "loading"
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode("加载中...")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.block.bank_card_name), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.block.bank_name), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.block.bank_branch), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.block.bank_card_account), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.block.bank_remark), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_van_button, {
          type: "primary",
          size: "small",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copy('开户名：'+_ctx.block.bank_card_name + ' \n开户银行：' + _ctx.block.bank_name + ' \n开户支行：' + _ctx.block.bank_branch + ' \n银行账号：' + _ctx.block.bank_card_account + ' \n转账备注：' + _ctx.block.bank_remark)))
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_21,
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.pay.biaodi_name), 1)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.pay.biaodi_no), 1)
      ]),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("span", _hoisted_31, "￥" + _toDisplayString(_ctx.pay.pay_money), 1)
      ]),
      _hoisted_32
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createVNode(_component_van_loading, {
            size: "24px",
            vertical: "",
            color: "#0094ff"
          }, {
            default: _withCtx(() => [
              _hoisted_34
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}